export var REJECTION_CODES_TEXT = {
    pageTitle: "Códigos de Rechazo",
    pageSubtitle: "Configurá cómo se interpreta cada código de respuesta al procesar un cobro — a qué transacción corresponde y qué acción tomar.",
    newSetButton: "+ Nuevo set",
    setsListLabel: "Sets de este cliente",
    enabledStatus: "Habilitado",
    disabledStatus: "Deshabilitado",
    enableButton: "Habilitar",
    disableButton: "Deshabilitar",
    deleteButton: "Eliminar",
    deleteHint: "Eliminar se habilita después de deshabilitar el set.",
    addCodeLabel: "Agregar código",
    addCodeButton: "+ Agregar",
    codePlaceholder: "Código",
    labelPlaceholder: "Etiqueta",
    transactionPlaceholder: "Transacción",
    descriptionPlaceholder: "Descripción",
    actionPlaceholder: "Acción (opcional)",
    actionDescriptionPlaceholder: "Detalle de acción (opcional)",
    newSetModalTitle: "Nuevo set de códigos de rechazo",
    newSetModalSubtitle: "Necesita un nombre, un código corto, y al menos un código de rechazo para poder crearse. Podés agregar el resto después.",
    newSetSectionSetData: "Datos del set",
    newSetSectionCodes: "Códigos de rechazo",
    newSetCodesHint: "Se guardan acá en memoria, no se mandan al servidor todavía — recién al crear el set van todos juntos, sean 1 o 50.",
    newSetNameLabel: "Nombre",
    newSetNamePlaceholder: "Ej. APAP rejection codes",
    newSetShortCodeLabel: "Código corto",
    newSetShortCodePlaceholder: "Ej. APAP",
    newSetDraftEmpty: "Todavía no agregaste ningún código.",
    newSetDraftError: "Agregá al menos un código antes de crear el set.",
    cancelButton: "Cancelar",
    createSetButton: "Crear set",
    renameModalTitle: "Editar nombre del set",
    renameNameLabel: "Nombre",
    saveButton: "Guardar",
    nameRequiredError: "Ingresá un nombre para el set.",
    shortCodeRequiredError: "Ingresá un código corto (máx. 60 caracteres).",
    codeRequiredError: "Ingresá un código.",
    labelRequiredError: "Ingresá una etiqueta.",
    transactionRequiredError: "Seleccioná una transacción.",
    descriptionRequiredError: "Ingresá una descripción.",
    codesEmptyMessage: "Este set todavía no tiene códigos de rechazo.",
    noSetsTitle: "Todavía no hay sets de códigos de rechazo",
    noSetsMessage: 'Creá el primero con el botón "+ Nuevo set".',
    selectSetTitle: "Ningún set seleccionado",
    selectSetMessage: "Elegí un set de la lista para ver y editar sus códigos.",
    createSetSuccess: "Set creado correctamente.",
    renameSetSuccess: "Nombre del set actualizado correctamente.",
    addCodeSuccess: "Código agregado correctamente.",
    updateCodeSuccess: "Código actualizado correctamente.",
    removeCodeSuccess: "Código eliminado correctamente.",
    disableSetSuccess: "Set deshabilitado correctamente.",
    deleteSetSuccess: "Set eliminado correctamente.",
    confirmDisableTitle: "¿Deshabilitar este set?",
    confirmDisableMessage: "Esta acción no se puede deshacer: no existe forma de volver a habilitarlo. El set quedará de solo lectura y solo se podrá eliminar.",
    confirmDisableButton: "Sí, deshabilitar",
    confirmDeleteTitle: "¿Eliminar este set?",
    confirmDeleteMessage: "Esta acción no se puede deshacer. El set y todos sus códigos se eliminarán de forma permanente.",
    confirmDeleteButton: "Sí, eliminar",
};
export var REJECTION_CODES_FILTER_OPTIONS = [
    { value: "all", label: "Todos" },
    { value: "enabled", label: "Habilitados" },
    { value: "disabled", label: "Deshabilitados" },
];
export var REJECTION_CODES_TRANSACTION_LABEL_ES = {
    CREDIT: "Crédito",
    DEBIT: "Débito",
    REBILL: "Recobro",
    REJECTED: "Rechazado",
    CANCELLED: "Cancelado",
};
export var REJECTION_CODES_TRANSACTION_VALUE_BY_LABEL = Object.fromEntries(Object.entries(REJECTION_CODES_TRANSACTION_LABEL_ES).map(function (_a) {
    var value = _a[0], label = _a[1];
    return [label, value];
}));
export var REJECTION_CODES_TRANSACTION_OPTIONS = [
    { value: "CREDIT", label: REJECTION_CODES_TRANSACTION_LABEL_ES.CREDIT },
    { value: "DEBIT", label: REJECTION_CODES_TRANSACTION_LABEL_ES.DEBIT },
    { value: "REBILL", label: REJECTION_CODES_TRANSACTION_LABEL_ES.REBILL },
    { value: "REJECTED", label: REJECTION_CODES_TRANSACTION_LABEL_ES.REJECTED },
    {
        value: "CANCELLED",
        label: REJECTION_CODES_TRANSACTION_LABEL_ES.CANCELLED,
    },
];
export var REJECTION_CODES_TABLE_HEADERS = {
    code: "Código",
    label: "Etiqueta",
    transaction: "Transacción",
    description: "Descripción",
    action: "Acción",
    actionDescription: "Detalle de acción",
};
